"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const wizard_1 = __importDefault(require("@App/routes/rightsholder/creatework/wizard"));
const form_1 = __importDefault(require("@App/routes/rightsholder/creatework/form"));
const bulk_1 = __importDefault(require("@App/routes/rightsholder/creatework/bulk"));
const navigation_1 = __importDefault(require("@App/navigation"));
const RedirectToRightsholderSummary_1 = __importDefault(require("@Components/RedirectToRightsholderSummary"));
const react_router_dom_1 = require("react-router-dom");
const permissions_1 = require("@Const/permissions");
const PermissionCheck_1 = __importDefault(require("@App/kit/components/PermissionCheck"));
const CreateWorkByWizardLayout_1 = __importDefault(require("@Scenes/WorkScenes/CreateWorkByWizardLayout"));
const route_1 = require("@App/navigation/route");
const createCreateWorkRoutes = () => {
    const createWorkByWizardRoutes = (0, wizard_1.default)();
    const createWorkByFormRoutes = (0, form_1.default)();
    const createWorkByBulkRoutes = (0, bulk_1.default)();
    return {
        path: route_1.CREATE_WORK_ROUTE,
        element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
            react_1.default.createElement(react_router_dom_1.Outlet, null))),
        children: [
            {
                path: '',
                element: react_1.default.createElement(RedirectToRightsholderSummary_1.default, null),
            },
            {
                path: route_1.MANUAL_ROUTE,
                element: react_1.default.createElement(CreateWorkByWizardLayout_1.default, null),
            },
            createWorkByWizardRoutes,
            createWorkByFormRoutes,
            createWorkByBulkRoutes,
        ],
    };
};
exports.default = createCreateWorkRoutes;
